export default "__VITE_ASSET__BayfenmQ__"